import { Outlet, useNavigate } from "react-router-dom";

import { ModalErrorGeneric } from "~/components/kiosk/ui/modals/error/modal-error-generic";

import {
  ProductDetailProvider,
  useProductDetailData
} from "./product-detail-context";

export const KioskProductDetailLayoutPage = () => {
  const navigate = useNavigate();
  const result = useProductDetailData();

  if (result.status === "pending") {
    // TODO: replace with loading modal
    return <div>Loading...</div>;
  }

  if (result.status === "error") {
    return (
      <ModalErrorGeneric
        onClose={() => {
          navigate("/kiosk/products");
        }}
      />
    );
  }

  return (
    <ProductDetailProvider
      item={result.item}
      stampCardDiscount={result.stampCardDiscount}
    >
      <Outlet />
    </ProductDetailProvider>
  );
};
